// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/v1/end_user.proto" (package "viam.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message viam.app.v1.IsLegalAcceptedRequest
 */
export interface IsLegalAcceptedRequest {
}
/**
 * @generated from protobuf message viam.app.v1.IsLegalAcceptedResponse
 */
export interface IsLegalAcceptedResponse {
    /**
     * If false, the user should not be able to use the application.
     *
     * @generated from protobuf field: bool accepted_legal = 1;
     */
    acceptedLegal: boolean;
    /**
     * Whether the user has ever accepted any version of the legal terms.
     *
     * @generated from protobuf field: bool ever_accepted_legal = 2;
     */
    everAcceptedLegal: boolean;
}
/**
 * @generated from protobuf message viam.app.v1.AcceptLegalRequest
 */
export interface AcceptLegalRequest {
}
/**
 * @generated from protobuf message viam.app.v1.AcceptLegalResponse
 */
export interface AcceptLegalResponse {
}
/**
 * @deprecated
 * @generated from protobuf message viam.app.v1.RegisterAuthApplicationRequest
 */
export interface RegisterAuthApplicationRequest {
    /**
     * @generated from protobuf field: string application_name = 1;
     */
    applicationName: string;
    /**
     * @generated from protobuf field: string org_id = 2;
     */
    orgId: string;
    /**
     * @generated from protobuf field: repeated string origin_uris = 3;
     */
    originUris: string[];
    /**
     * @generated from protobuf field: repeated string redirect_uris = 4;
     */
    redirectUris: string[];
    /**
     * @generated from protobuf field: string logout_uri = 5;
     */
    logoutUri: string;
}
/**
 * @deprecated
 * @generated from protobuf message viam.app.v1.RegisterAuthApplicationResponse
 */
export interface RegisterAuthApplicationResponse {
    /**
     * @generated from protobuf field: string application_id = 1;
     */
    applicationId: string;
    /**
     * @generated from protobuf field: string application_name = 2;
     */
    applicationName: string;
    /**
     * @generated from protobuf field: string client_secret = 3;
     */
    clientSecret: string;
}
/**
 * @deprecated
 * @generated from protobuf message viam.app.v1.UpdateAuthApplicationRequest
 */
export interface UpdateAuthApplicationRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string application_id = 2;
     */
    applicationId: string;
    /**
     * @generated from protobuf field: string application_name = 3;
     */
    applicationName: string;
    /**
     * @generated from protobuf field: repeated string origin_uris = 4;
     */
    originUris: string[];
    /**
     * @generated from protobuf field: repeated string redirect_uris = 5;
     */
    redirectUris: string[];
    /**
     * @generated from protobuf field: string logout_uri = 6;
     */
    logoutUri: string;
}
/**
 * @deprecated
 * @generated from protobuf message viam.app.v1.UpdateAuthApplicationResponse
 */
export interface UpdateAuthApplicationResponse {
    /**
     * @generated from protobuf field: string application_id = 1;
     */
    applicationId: string;
    /**
     * @generated from protobuf field: string application_name = 2;
     */
    applicationName: string;
}
/**
 * @deprecated
 * @generated from protobuf message viam.app.v1.GetAuthApplicationRequest
 */
export interface GetAuthApplicationRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string application_id = 2;
     */
    applicationId: string;
}
/**
 * @deprecated
 * @generated from protobuf message viam.app.v1.GetAuthApplicationResponse
 */
export interface GetAuthApplicationResponse {
    /**
     * @generated from protobuf field: string application_id = 1;
     */
    applicationId: string;
    /**
     * @generated from protobuf field: string application_name = 2;
     */
    applicationName: string;
    /**
     * @generated from protobuf field: string client_secret = 3;
     */
    clientSecret: string;
    /**
     * @generated from protobuf field: repeated string origin_uris = 4;
     */
    originUris: string[];
    /**
     * @generated from protobuf field: repeated string redirect_uris = 5;
     */
    redirectUris: string[];
    /**
     * @generated from protobuf field: string logout_uri = 6;
     */
    logoutUri: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class IsLegalAcceptedRequest$Type extends MessageType<IsLegalAcceptedRequest> {
    constructor() {
        super("viam.app.v1.IsLegalAcceptedRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.IsLegalAcceptedRequest
 */
export const IsLegalAcceptedRequest = new IsLegalAcceptedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsLegalAcceptedResponse$Type extends MessageType<IsLegalAcceptedResponse> {
    constructor() {
        super("viam.app.v1.IsLegalAcceptedResponse", [
            { no: 1, name: "accepted_legal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "ever_accepted_legal", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.IsLegalAcceptedResponse
 */
export const IsLegalAcceptedResponse = new IsLegalAcceptedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcceptLegalRequest$Type extends MessageType<AcceptLegalRequest> {
    constructor() {
        super("viam.app.v1.AcceptLegalRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AcceptLegalRequest
 */
export const AcceptLegalRequest = new AcceptLegalRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcceptLegalResponse$Type extends MessageType<AcceptLegalResponse> {
    constructor() {
        super("viam.app.v1.AcceptLegalResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.v1.AcceptLegalResponse
 */
export const AcceptLegalResponse = new AcceptLegalResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterAuthApplicationRequest$Type extends MessageType<RegisterAuthApplicationRequest> {
    constructor() {
        super("viam.app.v1.RegisterAuthApplicationRequest", [
            { no: 1, name: "application_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "origin_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "redirect_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "logout_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.v1.RegisterAuthApplicationRequest
 */
export const RegisterAuthApplicationRequest = new RegisterAuthApplicationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterAuthApplicationResponse$Type extends MessageType<RegisterAuthApplicationResponse> {
    constructor() {
        super("viam.app.v1.RegisterAuthApplicationResponse", [
            { no: 1, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "application_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.v1.RegisterAuthApplicationResponse
 */
export const RegisterAuthApplicationResponse = new RegisterAuthApplicationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAuthApplicationRequest$Type extends MessageType<UpdateAuthApplicationRequest> {
    constructor() {
        super("viam.app.v1.UpdateAuthApplicationRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "application_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "origin_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "redirect_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "logout_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.v1.UpdateAuthApplicationRequest
 */
export const UpdateAuthApplicationRequest = new UpdateAuthApplicationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAuthApplicationResponse$Type extends MessageType<UpdateAuthApplicationResponse> {
    constructor() {
        super("viam.app.v1.UpdateAuthApplicationResponse", [
            { no: 1, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "application_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.v1.UpdateAuthApplicationResponse
 */
export const UpdateAuthApplicationResponse = new UpdateAuthApplicationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAuthApplicationRequest$Type extends MessageType<GetAuthApplicationRequest> {
    constructor() {
        super("viam.app.v1.GetAuthApplicationRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.v1.GetAuthApplicationRequest
 */
export const GetAuthApplicationRequest = new GetAuthApplicationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAuthApplicationResponse$Type extends MessageType<GetAuthApplicationResponse> {
    constructor() {
        super("viam.app.v1.GetAuthApplicationResponse", [
            { no: 1, name: "application_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "application_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "origin_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "redirect_uris", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "logout_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message viam.app.v1.GetAuthApplicationResponse
 */
export const GetAuthApplicationResponse = new GetAuthApplicationResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.v1.EndUserService
 */
export const EndUserService = new ServiceType("viam.app.v1.EndUserService", [
    { name: "IsLegalAccepted", options: {}, I: IsLegalAcceptedRequest, O: IsLegalAcceptedResponse },
    { name: "AcceptLegal", options: {}, I: AcceptLegalRequest, O: AcceptLegalResponse },
    { name: "RegisterAuthApplication", options: {}, I: RegisterAuthApplicationRequest, O: RegisterAuthApplicationResponse },
    { name: "UpdateAuthApplication", options: {}, I: UpdateAuthApplicationRequest, O: UpdateAuthApplicationResponse },
    { name: "GetAuthApplication", options: {}, I: GetAuthApplicationRequest, O: GetAuthApplicationResponse }
]);
